import React, { useEffect, useState } from 'react';
import { Modal, Spin, Typography } from 'antd';
import { KnowledgeItemVo, getItemDetail } from '@/api/knowledgeBase';

const { Text } = Typography;

export interface ViewItemProp {
  data: KnowledgeItemVo;
  onClose: () => void;
}

const ViewItem = ({ data, onClose }: ViewItemProp) => {
  const [detail, setDetail] = useState<KnowledgeItemVo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data?.id) {
      setLoading(true);
      getItemDetail(data.id)
        .then(res => setDetail(res))
        .catch(() => setDetail(data))
        .finally(() => setLoading(false));
    }
  }, [data?.id, data]);

  const item = detail || data;
  const isConfig = item.kind === 'config';

  return (
    <Modal
      title={`查看条目 - ${item.name}`}
      open={true}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div style={{ marginBottom: 16 }}>
            <Text strong>条目类型：</Text>
            <Text>{isConfig ? '配置文档' : 'RAG 文档'}</Text>
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>格式：</Text>
            <Text>{item.format || '未知'}</Text>
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>状态：</Text>
            <Text>{item.status === 2 ? '已完成' : item.status === 1 ? '处理中' : '待处理'}</Text>
          </div>
          {item.kind === 'config' && (
            <div style={{ marginBottom: 16 }}>
              <Text strong>配置解析：</Text>
              <Text type="success">已解析</Text>
            </div>
          )}
          {item.kind === 'rag' && (
            <div style={{ marginBottom: 16 }}>
              <Text strong>分块数量：</Text>
              <Text>{item.chunkCount ?? 0}</Text>
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <Text strong>创建时间：</Text>
            <Text>{item.createdAt || '-'}</Text>
          </div>
          {item.errorMessage && (
            <div style={{ marginBottom: 16 }}>
              <Text strong type="danger">错误信息：</Text>
              <Text type="danger">{item.errorMessage}</Text>
            </div>
          )}
          {item.rawContent && (
            <div>
              <Text strong>内容：</Text>
              <pre style={{
                background: '#f5f5f5',
                padding: 16,
                borderRadius: 4,
                maxHeight: 400,
                overflow: 'auto',
                fontSize: 12,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
              }}>
                {item.rawContent}
              </pre>
            </div>
          )}
          {!item.rawContent && (
            <div>
              <Text type="secondary">该条目暂无内容（可能是文件上传类型）</Text>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default ViewItem;
